import paginationsTemplates from './paginationsTemplates';

import {
  Numeral,
  Carousel,
  VerticalCarousel,
  ViewsPerPage,
} from './paginationsLayouts';

const paginationsSet = [
  {
    component: Numeral,
    codeTemplate: paginationsTemplates.numeral,
    optionsGroup: [
      {
        label: 'Numeral',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '2 Pages', value: '2', options: {totalItems: 2, __key: 2}},
            {label: '3 Pages', value: '3', options: {totalItems: 3, __key: 3}},
            {label: '4 Pages', value: '4', options: {totalItems: 4, __key: 4}},
            {label: '5 Pages', value: '5', options: {totalItems: 5, __key: 5}},
            {label: '6 Pages', value: '6', options: {totalItems: 6, __key: 6}},
            {label: '7 Pages', value: '7', options: {totalItems: 7, __key: 7}},
            {label: '8 Pages', value: '8', options: {totalItems: 8, __key: 8}},
            {label: '9 Pages', value: '9', options: {totalItems: 9, __key: 9}},
            {label: '10 Pages', value: '10', options: {totalItems: 10, __key: 10}},
            {label: '11 Pages', value: '11', options: { totalItems: 11, __key: 11 }},
            {label: '12 Pages', value: '12', options: { totalItems: 12, __key: 12 }},
            ],
          }
        ]
      },
    ]
  },
  {
    component: Carousel,
    codeTemplate: paginationsTemplates.carousel,
    optionsGroup: [
      {
        label: 'Horizontal Carousel',
        options: [
          {label: 'static', type: 'radio', options:{autoplay: false, __key: 'numeral'}},
          {label: 'timer', type: 'radio', options:{autoplay: true, __key: 'numeralAutoPlay'}},
        ]
      },
      {
        label: 'Background',
        options: [
          {label: 'light', type: 'radio', options: {bgColor: null, dark: false}},
          {label: 'dark', type: 'radio', options: {bgColor: 'black', dark: true}},
        ]
      },
      {
        label: 'Counter',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '8 Pages', value: '8', options: {totalItems: 8, __key: 8}},
            {label: '7 Pages', value: '7', options: {totalItems: 7, __key: 7}},
            {label: '6 Pages', value: '6', options: {totalItems: 6, __key: 6}},
            {label: '5 Pages', value: '5', options: {totalItems: 5, __key: 5}},
            {label: '4 Pages', value: '4', options: {totalItems: 4, __key: 4}},
            {label: '3 Pages', value: '3', options: {totalItems: 3, __key: 3}},
            {label: '2 Pages', value: '2', options: {totalItems: 2, __key: 2}},
            ],
          }
        ]
      },
    ],
  },
  {
    component: VerticalCarousel,
    codeTemplate: paginationsTemplates.verticalCarousel,
    optionsGroup: [
      {
        label: 'Vertical Carousel',
        options: [
          {label: 'large', type: 'radio', options:{size: 'large'}},
          {label: 'small', type: 'radio', options:{size: 'small'}},
        ]
      },
      {
        label: 'Counter',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '8 Pages', value: '8', options: {totalItems: 8, __key: 8}},
            {label: '7 Pages', value: '7', options: {totalItems: 7, __key: 7}},
            {label: '6 Pages', value: '6', options: {totalItems: 6, __key: 6}},
            {label: '5 Pages', value: '5', options: {totalItems: 5, __key: 5}},
            {label: '4 Pages', value: '4', options: {totalItems: 4, __key: 4}},
            {label: '3 Pages', value: '3', options: {totalItems: 3, __key: 3}},
            {label: '2 Pages', value: '2', options: {totalItems: 2, __key: 2}},
            ],
          }
        ]
      },
    ],
  },
  {
    component: ViewsPerPage,
    codeTemplate: paginationsTemplates.viewsPerPage,
    optionsGroup: [
      {
        label: 'Views per Page',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: 'Show', value: 'sh', options: {label: 'Show', __key: 'viewsPerPage'}},
            {label: 'Rates per page', value: 'rpp', options: {label: 'Rates per page', __key: 'ratesPerPage'}},
            {label: 'Requests per page', value: 'reqpp', options: {label: 'Requests per page', __key: 'RequestsPerPage'}},
            {label: 'Payments per page', value: 'ppp', options: {label: 'Payments per page', __key: 'PaymentsPerPage'}},
            ],
          }
        ]
      },
      {
        label: '',
        options: [
          {label: 'sizes', type:
           'dropdown', selectList: [
            {label: '10 Pages', value: '10', options: {max: 10}},
            {label: '9 Pages', value: '9', options: {max: 9}},
            {label: '8 Pages', value: '8', options: {max: 8}},
            {label: '7 Pages', value: '7', options: {max: 7}},
            {label: '6 Pages', value: '6', options: {max: 6}},
            {label: '5 Pages', value: '5', options: {max: 5}},
            {label: '4 Pages', value: '4', options: {max: 4}},
            {label: '3 Pages', value: '3', options: {max: 3}},
            {label: '2 Pages', value: '2', options: {max: 2}},
            {label: '1 Page', value: '1', options: {max: 1}},
            ],
          }
        ]
      },
    ],
  },
];

export default paginationsSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Paginations/constants/paginationsSet.js